import { Button, Flex, ModalBody, ModalFooter, Text, VStack } from '@chakra-ui/react'
import { DefaultModal } from '@components/Modals'

interface WeightBypassModalProps {
  isOpen: boolean
  onProceed: () => void
  onCancel: () => void
}

// §2.4: Tier 1.5 weight bypass — fires when provider authenticates a routine antepartum note
// without documenting weight. "Proceed" logs a timestamped bypass acknowledgment in encounter data.
export const WeightBypassModal = ({ isOpen, onProceed, onCancel }: WeightBypassModalProps) => (
  <DefaultModal
    isOpen={isOpen}
    onClose={onCancel}
    header="Weight Not Documented"
    render={() => (
      <>
        <ModalBody>
          <VStack align="flex-start" spacing={3}>
            <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.300' }}>
              Weight has not been documented for this visit. Weight is a standard component of
              antepartum care per ACNM guidelines. Bypassing this field may impact the clinical
              completeness of this record.
            </Text>
            <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.300' }}>
              Do you want to proceed without documenting weight?
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Flex w="100%" gap={2} justify="flex-end">
            <Button size="sm" variant="outline" colorScheme="gray" onClick={onCancel}>
              Cancel — Go Back
            </Button>
            <Button size="sm" colorScheme="orange" onClick={onProceed}>
              Proceed Without Weight
            </Button>
          </Flex>
        </ModalFooter>
      </>
    )}
  />
)
